import Env from '../../base/env';
import Channels from '../../base/channels';
import Component from 'gia/Component';
import gsap from 'gsap';
import { ScrollTrigger } from '../../vendor/gsap-bonus-umd/ScrollTrigger';
import easesCustom from '../../fx/CustomEases';
gsap.registerPlugin(ScrollTrigger);

export default class Module extends Component
{
  mount() {
    this.DOM = {}
    this.DOM.view = this.element
    this.DOM.cache = this.DOM.view.querySelector('.fxCacheSEO')
    this.DOM.fade = this.DOM.view.querySelector('.fxFade')
    this.DOM.imgs = [this.DOM.view.querySelector('.fxImg1'),this.DOM.view.querySelector('.fxImg2'),this.DOM.view.querySelector('.fxImg3')]
    this.DOM.svgGroups = this.DOM.view.querySelectorAll('.fxTitle g')
    this.DOM.letter = this.DOM.view.querySelector('.fxLetter')
    // //! Fns
    this.fadeScroll()
    this.makeSticky()
    this.createMasks()
    this.funcLaunch = this._fx.bind(this)
    this.funcResize = this.resize.bind(this)

    Channels.on('launcher::exit',this.funcLaunch)
    Channels.on('transition::end',this.funcLaunch)
    Channels.on('window::smartresize',this.funcResize)
  }

  _fx()
  {
    console.log('reveal');
    this.reveal()
  }

  createMasks()
  {
    const dimensions = this.DOM.imgs[0].getBoundingClientRect()
    const clipRectImg1 = `rect(0px,${dimensions.width}px,${dimensions.height * .5}px,0px)`;
    const clipRectImg2 = `rect(${dimensions.height * .5}px,${dimensions.width}px,${dimensions.height * .8}px,0px)`;
    const clipRectImg3 = `rect(${dimensions.height * .8}px,${dimensions.width}px,${dimensions.height}px,0px)`;

    gsap.set(this.DOM.imgs[0], { clip:clipRectImg1 })
    gsap.set(this.DOM.imgs[1], { clip:clipRectImg2 })
    gsap.set(this.DOM.imgs[2], { clip:clipRectImg3 })
  }

  fadeScroll()
  {

    this.fade = ScrollTrigger.create({
      trigger:document.body,
      start:'top top',
      end:'+=100%',
      invalidateOnRefresh: true,
      onUpdate:(e)=>{
        gsap.set(this.DOM.fade,{ autoAlpha: e.progress / 2})
      }
    })
  }

  makeSticky()
  {
    this.sticky = ScrollTrigger.create({
      trigger:this.DOM.view,
      start:'top top',
      pin:this.DOM.title,
      pinSpacing:false,
      end: () => ScrollTrigger.maxScroll(document.body),
      invalidateOnRefresh: true
    })
  }

  reveal()
  {
    this.animation = gsap.timeline()

    this.animation
    .add([
      gsap.fromTo(
        this.DOM.cache,
        {
          autoAlpha:1
        },
        {
          autoAlpha:0,
          duration:.2,
          ease:easesCustom.cubic
        }
      ),
      gsap.set(this.DOM.imgs, { autoAlpha:1})
    ])
    .add([
      gsap.fromTo(
        this.DOM.imgs,
        {
          y:'-100%',
        },
        {
          y:0,
          duration:1,
          stagger:.09,
          ease:easesCustom.quart
        }
      ),
    ])
    .add([
      gsap.fromTo(
        this.DOM.letter,
        {
          autoAlpha:0,
          scale:1.2
        },
        {
          autoAlpha:1,
          scale:1.01,
          ease:easesCustom.quart,
          duration:1.2
        }
      )
    ],'-=.8')
    .add([
      gsap.fromTo(
        this.DOM.svgGroups[0].querySelectorAll('path'),
        {
          y:'110%'
        },
        {
          y:0,
          ease:'quint.out',
          duration:1
        }
      ),
      gsap.fromTo(
        this.DOM.svgGroups[1].querySelectorAll('path'),
        {
          y:'-110%'
        },
        {
          y:0,
          ease:'quint.out',
          duration:1
        }
      ),
    ],'-=.4')
  }

  resize()
  {
    gsap.set([this.DOM.bgLeft,this.DOM.bgRight], { clearProps:'clip'})
  }

  unmount()
  {
    Channels.removeListener('launcher::exit',this.funcLaunch)
    Channels.removeListener('transition::end',this.funcLaunch)
    Channels.removeListener('window::smartresize',this.funcResize)
    this.fade.kill()
    this.sticky.kill()
  }
}
